import DocutaxRequestSearchResult from './DocutaxRequestSearchResult';

export default class DocutaxRequestSearchResultPage {
  /**
   * @type {DocutaxRequestSearchResult[]}
   */
  content = [];

  /**
   * @type {number}
   */
  page = 0;

  /**
   * @type {number}
   */
  pageSize = 20;

  /**
   * @type {number}
   */
  totalElements = 0;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.content != null) {
        this.content = opts.content.map(val => new DocutaxRequestSearchResult(val));
      }
      if (opts.page != null) {
        this.page = opts.page;
      }
      if (opts.pageSize != null) {
        this.pageSize = opts.pageSize;
      }
      if (opts.totalElements != null) {
        this.totalElements = opts.totalElements;
      }
    }
  }
}
